import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import LinkPlugin from '../../../../plugins/LinkPlugin';
import createStore from '../../../../plugins/utils/createStore';
import { HeaderOneIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import textSort from '../utils/textSort';
import TextField from './TextField';
import makeOnStartTyping from './makeOnStartTyping';
var TEXT_COLUMN_TYPES = [ColumnTypes.TEXT, ColumnTypes.NAME];
export default function TextPlugin() {
  var store = createStore();

  var plugins = _toConsumableArray(LinkPlugin());

  return [makeOnStartTyping(TEXT_COLUMN_TYPES, store), {
    getWidth: function getWidth(columnType, database, next) {
      if (TEXT_COLUMN_TYPES.includes(columnType)) {
        return 280;
      }

      return next();
    },
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      if (TEXT_COLUMN_TYPES.includes(columnType)) {
        return React.createElement(HeaderOneIcon, {
          size: 12
        });
      }

      return next();
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      if (columnType === ColumnTypes.TEXT) {
        return 'Text';
      }

      if (columnType === ColumnTypes.NAME) {
        return 'Name';
      }

      return next();
    },
    canDelete: function canDelete(columnType, database, next) {
      if (columnType === ColumnTypes.NAME) {
        return false;
      }

      return next();
    },
    canSort: function canSort(columnType, database, next) {
      if (!TEXT_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return true;
    },
    getSortOptions: function getSortOptions(columnType, database, next) {
      if (!TEXT_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return textSort.options;
    },
    getSortStrategies: function getSortStrategies(columnType, database, next) {
      if (!TEXT_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return textSort.strategies(columnType, database);
    },
    renderField: function renderField(_ref, database, next) {
      var field = _ref.field,
          record = _ref.record,
          isFocused = _ref.isFocused,
          column = _ref.column;

      if (!TEXT_COLUMN_TYPES.includes(column.type)) {
        return next();
      }

      var fieldKey = database.getFieldKey(record.key, column.key);
      var storeItem = store.getItem(fieldKey);
      var value = storeItem ? storeItem.initialValue : field.data.text || '';
      return React.createElement(TextField, {
        database: database,
        value: value,
        recordKey: record.key,
        columnKey: column.key,
        isFocused: isFocused,
        store: store,
        plugins: plugins
      });
    },
    convertField: function convertField(source, destination, database, next) {
      if (!TEXT_COLUMN_TYPES.includes(destination.column.type)) return next();
      var fieldAsText = typeof source === 'string' ? source : database.run('serializeField', source);
      return {
        text: fieldAsText
      };
    },
    serializeField: function serializeField(_ref2, database, next) {
      var column = _ref2.column,
          field = _ref2.field;
      if (!TEXT_COLUMN_TYPES.includes(column.type)) return next();
      return field.data.text;
    }
  }];
}